// Word Frequency Tool — count which words appear most in a text.
import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const wordFrequencyTool: Tool = {
  id: "word-frequency",
  name: () => m.wf_tool_name(),
  description: () => m.wf_tool_description(),
  icon: "📊",
  basePath: "/word-frequency",
  status: "stable",
  tags: ["text", "frequency", "words", "analysis"],
  pages: [
    {
      name: () => m.wf_nav_main(),
      path: "/word-frequency",
      description: () => m.wf_nav_main_desc(),
      icon: "📊",
    },
  ],
};
